import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StickyContainer, Sticky } from 'react-sticky';

import { Layout } from 'antd';
import Sider from './components/Sider';
import Drawer from './components/Drawer';
import CustomModal from "../components/Modal/CustomModal";

import {
  loadConfiguration,
  resetSettings,
  translations,
} from '../containers/Construction/construction.reducer';

import Scene from '../containers/Scene';
import ContainerHeader from '../containers/ContainerHeader';
import ConstructionFooter from '../containers/ConstructionFooter';

import { ContainerHeaderWrapper } from './App.styles';

import useWindowDimensions from '../utils/useWindowDimensions';
import {TranslationProvider} from "../contexts/TranslationContext";
import {ModalProvider} from "../contexts/ModalContext";

const { Content } = Layout;

const App = ({
  loadConfigurationCallback,
  resetSettingsCallback,
  translationsCallback,
  translationsData,
}) => {
  const collapsed = false;
  const { width } = useWindowDimensions();

  useEffect(() => {
    loadConfigurationCallback();
    translationsCallback();
  }, []);

  return (
    <TranslationProvider translations={translationsData}>
      <ModalProvider>
        <Layout style={{ marginTop: -75 }}>
          <ContainerHeaderWrapper>
            <ContainerHeader/>
          </ContainerHeaderWrapper>
          <Sider collapsed={collapsed} resetSettings={resetSettingsCallback} />
          <Layout>
            {
              width > 1150 ? (
                <React.Fragment>
                  <StickyContainer style={{ height: '100%' }}>
                    <Sticky style={{ height: '100%' }}>
                      {({ style, isSticky }) => (
                        <Content style={{ ...style, width: 690, margin: '0 0 20px 16px' }}>
                          <Scene
                            big={collapsed}
                          />
                          {translationsData.project_visualization || "project_visualization"}
                          <ConstructionFooter isSticky={isSticky}/>
                        </Content>
                      )}
                    </Sticky>
                  </StickyContainer>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Content>
                    <Scene
                      big={collapsed}
                    />
                    <ConstructionFooter/>
                  </Content>
                </React.Fragment>
              )
            }
          </Layout>
          <Drawer />
          <CustomModal />
        </Layout>
      </ModalProvider>
    </TranslationProvider>
  );
};

App.propTypes = {
  loadConfigurationCallback: PropTypes.func.isRequired,
  resetSettingsCallback: PropTypes.func.isRequired,
  translationsCallback: PropTypes.func.isRequired,
  translationsData: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  loadConfigurationCallback: loadConfiguration,
  resetSettingsCallback: resetSettings,
  translationsCallback: translations,
};

const mapStateToProps = (state) => ({
  translationsData: state.Construction.translations,
});


export default connect(mapStateToProps, mapDispatchToProps)(App);
